import { render, staticRenderFns } from "./bar-credits.vue?vue&type=template&id=662a3eaf&"
import script from "./bar-credits.vue?vue&type=script&lang=js&"
export * from "./bar-credits.vue?vue&type=script&lang=js&"
import style0 from "./bar-credits.vue?vue&type=style&index=0&id=662a3eaf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports